import { Type } from '@angular/core';

type PageLoader = () => Promise<Type<unknown>>;

// Use these in `loadComponent`: `import('@pages')` would put every page in one lazy chunk.
export const loadAccessibilityPage: PageLoader = () =>
    import('./accessibility/accessibility.component').then(m => m.AccessibilityComponent);
export const loadCookiesPage: PageLoader = () => import('./cookies/cookies.component').then(m => m.CookiesComponent);
export const loadErrorPage: PageLoader = () => import('./error/error.component').then(m => m.ErrorComponent);
export const loadLandpage: PageLoader = () => import('./landpage/landpage.component').then(m => m.LandpageComponent);
export const loadTestdevPage: PageLoader = () =>
    import('./testdev/testdev-shell/testdev-shell.component').then(m => m.TestdevShellComponent);
